import * as yup from "yup";

/**
 * Validation schema of the login form: studio name, artist code (Kuerzel) and password.
 */
export const loginSchema = yup.object().shape({
    studio: yup.string().required(),
    artist: yup.string().required(),
    password: yup.string().required(),
});
